import React from 'react';
import { useRequirementsAndPayContext } from '../../context';
import { Colors, RadioGroup, Text } from 'library';
import { ReportProblemRounded } from '@mui/icons-material';
import { styled } from '@mui/material';
import { FLORIDA_45_HOURS_ID } from '../../constants';
import { GenericChoice, Qualification } from '../../types';
import { booleanChoice } from '../../utils/choices';

export function FloridaRequirements({
    update,
}: {
    update: (
        value: number | number[],
        choices: GenericChoice[],
        qualification: Qualification | null,
        category: 'education' | 'experience' | 'multiple' | 'single' | 'boolean',
    ) => void;
}) {
    const { initialScale, qualifications } = useRequirementsAndPayContext();
    const flCredential = qualifications.boolean.find(
        (booleanQualification: GenericChoice) => booleanQualification.key === FLORIDA_45_HOURS_ID,
    );
    const selected = flCredential ? booleanChoice(initialScale, flCredential) : 'no';

    function onChange() {
        if (flCredential) {
            update(FLORIDA_45_HOURS_ID, [flCredential], null, 'boolean');
        }
    }

    return (
        <Question error={selected.toString()}>
            <div>
                <Text bold>Will you accept someone who is still finishing their DCF classes/exams?</Text>
                <Text variant="caption">
                    Note: All Tandem workers must complete DCF training within a year to maintain compliance.
                </Text>
                <RadioGroup
                    value={selected ? 'no' : 'yes'}
                    setValue={onChange}
                    values={{ yes: 'Yes', no: 'No' }}
                    horizontal
                    style={{ marginTop: 10 }}
                />
            </div>
            {selected && <ReportProblemRounded sx={{ height: 36, width: 36, color: Colors.error }} />}
        </Question>
    );
}

const Question = styled('div')(({ error }: { error?: string }) => ({
    alignItems: 'center',
    backgroundColor: error === 'true' ? '#fff5f5' : Colors.white,
    borderRadius: 10,
    border: error === 'true' ? `1px solid ${Colors.error}` : 'none',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 20px',
}));
